module.exports = __webpack_public_path__ + "img/S1051430.9dbb2f9a.jpg";